// FormsList.js
import React, { useState, useEffect } from 'react';
import { 
    Box, 
    Paper, 
    Typography,
    Button,
    CircularProgress,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Grid,
    Card,
    CardContent,
    CardActions
} from '@mui/material';
import VisibilityIcon from '@mui/icons-material/Visibility';
import AddIcon from '@mui/icons-material/Add';
import { APIApplicationFormListPublished } from '../../utilities/APIs';
import CachedIcon from '@mui/icons-material/Cached';
import { useAuth } from '../../users/AuthContext';

import { ApplicationForm } from './ApplicationForm';
import ApplicationsViewListing from './ApplicationsViewListing';

export default function ApplicationList() {
    const { makeAuthenticatedRequest } = useAuth();
    const [forms, setForms] = useState([]);
    const [currentView, setCurrentView] = useState("LISTING");
    const [selectedForm, setSelectedForm] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);    const fetchForms = async () => {
        setLoading(true);
        setError(null);          try {
            const response = await makeAuthenticatedRequest(APIApplicationFormListPublished);
            let data = response.data.reverse();
            setForms(data);
        } catch (err) {
            console.log("err"+err)
            setError(err.message || 'Failed to fetch forms');
        } finally {
            setLoading(false);
        }
    };
    
    useEffect(() => {
        fetchForms();
    }, []);

    const handleViewClick = (form) => {
        setSelectedForm(form);
        setCurrentView("VIEWING");
    };

    const handleAddNew = () => {
        setSelectedForm(null);
        setCurrentView("ADDING");
    };

    const handleBackToList = () => {
        setCurrentView("LISTING");
        setSelectedForm(null);
    };

    if (loading) {
        return (
            <Box display="flex" justifyContent="center" mt={4}>
                <CircularProgress />
            </Box>
        );
    }

    if (error) {
        return (
            <Box display="flex" justifyContent="center" mt={4}>
                <Typography color="error">{error}</Typography>
            </Box>
        );
    }

    return (
        <Box p={3}>
            {currentView === "LISTING" && (
                <>
                    {/* <Box display="flex" justifyContent="space-between" alignItems="center" mb={3}>
                        <Button 
                            variant="contained" 
                            color='secondary'
                            startIcon={<CachedIcon />}
                            onClick={fetchForms}
                        >
                            Reload Forms
                        </Button>
                        <Typography variant="h4">Available Application Forms</Typography>
                        <Button 
                            variant="contained" 
                            startIcon={<AddIcon />}
                            onClick={handleAddNew}
                        >
                            Add New Form
                        </Button>                    </Box> */}
                    
                    {forms.length === 0 ? (
                        <Box display="flex" justifyContent="center" alignItems="center" mt={4}>
                            <Typography variant="h6" color="text.secondary">
                                No published application forms are currently available.
                            </Typography>
                        </Box>
                    ) : (
                        <Grid container spacing={3}>
                        {forms.map((form) => {
                            const formData = typeof form.formConfigJson === 'string' 
                                ? JSON.parse(form.formConfigJson) 
                                : form.formConfigJson;
                            return (
                                <Grid item xs={12} sm={6} md={4} key={form.id}>
                                    <Card 
                                        sx={{ 
                                            borderRadius: '16px', // 50% would make it circular, 16px gives nice rounded corners
                                            boxShadow: 3, // This adds a nice shadow effect
                                            height: '100%',
                                            width:'50%',
                                            display: 'flex',
                                            // flexDirection: 'column',
                                            flexDirection: 'column',
                                            transition: 'transform 0.3s, box-shadow 0.3s',
                                            '&:hover': {
                                                transform: 'translateY(-4px)',
                                                boxShadow: 6
                                            }
                                        }}
                                    >
                                        <CardContent sx={{ flexGrow: 1 }}>
                                            <Typography variant="h6" component="div" gutterBottom>
                                                {formData.name}
                                            </Typography>
                                            <Typography color="text.secondary" sx={{ mb: 1.5 }}>
                                                Category: {formData.type}
                                            </Typography>
                                            <Typography variant="body2">
                                                {formData.description || 'No description available'}
                                            </Typography>
                                        </CardContent>
                                        {/* <CardActions sx={{ justifyContent: 'flex-end' }}> */}
                                        <CardActions>
                                            <Button 
                                                size="small" 
                                                fullWidth
                                                variant="contained" 
                                                color="success"
                                                onClick={() => {
                                                    setSelectedForm(form);
                                                    setCurrentView("ADDING");
                                                }}
                                            >
                                                Start Application Now
                                            </Button>
                                        </CardActions>
                                    </Card>
                                </Grid>                            );
                        })}
                    </Grid>
                    )}
                </>
            )}

            {currentView === "VIEWING" && (
                <ApplicationsViewListing
                    formData={selectedForm} 
                    onCancel={handleViewClick}
                />
            )}

            {currentView === "ADDING" && (
                <ApplicationForm formId={selectedForm?.id} onCancel={handleBackToList}/>
            )}
        </Box>
    );
}